"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FlagSwallowtailOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var FlagSwallowtailOutlineSVG = function FlagSwallowtailOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M29.8 20.4l-5.52-7.36 5.48-6.39a1.02 1.02 0 00.15-1.07A1 1 0 0029 5H6V4a1 1 0 00-2 0v5H3a1 1 0 000 2h1v5H3a1 1 0 000 2h1v10a1 1 0 002 0v-6h23a1 1 0 00.8-1.6zM6 20v-2h2a1 1 0 000-2H6v-5h2a1 1 0 000-2H6V7h20.83l-4.59 5.35a1 1 0 00-.04 1.25L27 20z"
  }));
};
exports.FlagSwallowtailOutlineSVG = FlagSwallowtailOutlineSVG;
FlagSwallowtailOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(FlagSwallowtailOutlineSVG);
exports.default = _default;